import { MediaPipeInferenceEngine } from "../llm-inferences/MediaPipeInferenceEngine.js";
import { WebLLMInferenceEngine } from "../llm-inferences/WebLLMInferenceEngine.js";
import { OpenAIAzureInferenceEngine } from "../llm-inferences/OpenAIAzureLLMInferences.js";
import { HumanChatMessage } from "../types/ChatMessages.js";
export class BasicLLMInferenceEngine {
    llmInstance;
    config;
    openAiAzureInstance;
    constructor(config) {
        this.config = config;
        this.openAiAzureInstance = new OpenAIAzureInferenceEngine(config.fallBackModel, config.connectorUrl, config.apiKey);
    }
    setGlobalLLMInstance(llmModel, model, inferenceEngine) {
        window.llmModel = llmModel;
        window.llmModelName = model;
        window.llmEngine = inferenceEngine;
    }
    static async init(config) {
        const instance = new BasicLLMInferenceEngine(config);
        instance.config = config;
        if (config.mode === 'local' || config.mode === 'hybrid') {
            if (config.devMode) {
                instance.showSnackbar();
            }
            if (config.inferenceEngine === 'mediapipe') {
                const modelName = config.model == 'gemma' ? 'gemma-gpu' : config.model;
                if (!window.llmModel) {
                    instance.llmInstance = await MediaPipeInferenceEngine.init(modelName, false);
                    instance.setGlobalLLMInstance(instance.llmInstance, config.model, config.inferenceEngine);
                }
                else if (window.llmModelName !== config.model || window.llmEngine !== config.inferenceEngine) {
                    instance.llmInstance = await MediaPipeInferenceEngine.init(modelName, false);
                }
                else {
                    instance.llmInstance = window.llmModel;
                }
            }
            else if (config.inferenceEngine === 'webllm') {
                if (!window.llmModel) {
                    instance.llmInstance = await WebLLMInferenceEngine.init(config.model);
                    instance.setGlobalLLMInstance(instance.llmInstance, config.model, config.inferenceEngine);
                }
                else if (window.llmModelName !== config.model || window.llmEngine !== config.inferenceEngine) {
                    instance.llmInstance = await WebLLMInferenceEngine.init(config.model);
                }
                else {
                    instance.llmInstance = window.llmModel;
                }
            }
            else {
                throw new Error('Unsupported LLM Instance');
            }
        }
        return instance;
    }
    async generateInference(formattedPrompt) {
        if (this.config.mode === 'cloud') {
            console.log('Cloud Mode. Using OpenAI/Azure');
            const result = await this.openAiAzureInstance.runCompletionInference(formattedPrompt);
            return result;
        }
        else if (this.config.mode === 'hybrid' && this.llmInstance === undefined || this.llmInstance === null) {
            console.log('Hybrid Mode. Instance Not Initialized Yet. Using OpenAI/Azure');
            const result = await this.openAiAzureInstance.runCompletionInference(formattedPrompt);
            return result;
        }
        else {
            if (this.config.inferenceEngine === 'mediapipe') {
                return await this.getInferenceFromCompletion(formattedPrompt);
            }
            else if (this.config.inferenceEngine === 'webllm') {
                return await this.getInferenceFromChat(formattedPrompt);
            }
            else {
                throw new Error('Unsupported LLM Instance');
            }
        }
    }
    async getInferenceFromChat(formattedPrompt) {
        const chatMsg = [new HumanChatMessage(formattedPrompt)];
        const llmOutput = await this.llmInstance.runChatInference(chatMsg);
        return llmOutput[1].content;
    }
    async getInferenceFromCompletion(formattedPrompt) {
        console.time("LLM_call_Completion");
        const llmOutput = await this.llmInstance.runCompletionInference(formattedPrompt);
        console.timeEnd("LLM_call_Completion");
        return llmOutput;
    }
    async showSnackbar() {
        const snackBarHTML = `
            <div class="snackbar" 
            style="display: flex; align-items: center; position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); min-width: 288px; max-width: 568px; background-color: #323232; color: #fff; padding: 16px 24px; box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16); border-radius: 4px; font-family: 'Roboto', sans-serif; font-size: 14px;">
            Warning: The AI Model is ~1.5GB. It will take some time to load depending on your internet speed.
            Note: This is a one-time download. Subsequent loads will be faster.
            </div>`;
        document.body.insertAdjacentHTML('beforeend', snackBarHTML);
        setTimeout(() => {
            document.querySelector('.snackbar')?.remove();
        }, 5000);
    }
}
//# sourceMappingURL=BasicInferenceEngine.js.map